import React from "react";

import {
  messageContainer,
  primaryMessageStyle,
  secondaryMessageStyle,
  successStyle
} from "./Alert.css";
import { CloseButton } from "./CloseButton";
import { SuccessIcon } from "./SuccessIcon";
import { timeoutValue } from "./helpers";

export const DeprecatedSuccessAlert: React.FC<{
  primaryMessage: string;
  secondaryMessage: string;
  close?: () => void;
}> = ({ primaryMessage, secondaryMessage, close }) => {
  if (close) {
    setTimeout(() => {
      close();
    }, timeoutValue);
  }

  return (
    <div className={`${messageContainer} ${successStyle}`}>
      <div style={{ alignSelf: "flex-start" }}>
        <SuccessIcon style={{ marginTop: "6px" }} />
      </div>
      <div
        style={{
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div className={primaryMessageStyle}>{primaryMessage}</div>
          {close && <CloseButton width="28" height="28" onClick={close} />}
        </div>

        <div className={secondaryMessageStyle}>{secondaryMessage}</div>
      </div>
    </div>
  );
};
